module.exports = __webpack_public_path__ + "media/react/features/overview/suggestions/icons/slido-icon-ac8a8722b240a239f209fe0c89b09fc6.png";